import { Text } from '#app/components/Primitives/Text.js';
import { type ReactNode } from 'react';

export const StaticRouteLabel = ({
  children,
}: {
  readonly children: ReactNode;
}) => {
  return <Text textStyle="fifthLevelHeadline">{children}</Text>;
};
